import { Movie } from './GetFilmsAndShowtimes';

export type LocaleData = {
  title: string;
  synopsis: string;
  poster: string;
};

export const getBestTitle = (movie: Movie) => {
  return (
    movie.en_GB?.title || movie.fallback?.title || movie.originalTitle || ''
  );
};

export const getBestPoster = (movie: Movie) => {
  return (
    movie.en_GB?.poster || movie.fallback?.poster || movie.originalPoster || ''
  );
};
